export default __webpack_public_path__ + "46e3fc671094dbb04984a74cdc736fae.svg";